/**
 * Created by Ning Jiang on 3/20/2019.
 */

import {BeforeSpinStopPresentationController} from "@nolimitcity/slot-game/bin/core/beforespinstoppresentation/BeforeSpinStopPresentationController";
import {IGameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/IGameConfig";
import {IntroFeatureLogo} from "@nolimitcity/slot-game/bin/core/gameintro/GameIntroView";
import {IGameModuleConfig} from "@nolimitcity/slot-game/bin/core/gamemoduleconfig/IGameModuleConfig";
import {ReelPartCreator} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelPartCreator";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {ReelSymbolStateCreator} from "@nolimitcity/slot-game/bin/core/reelsymbol/ReelSymbolStateCreator";
import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {IFontsConfig} from "@nolimitcity/slot-game/bin/core/resource/font/IFontsConfig";
import {ResourcesGroupName} from "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName";
import {ISoundConfig} from "@nolimitcity/slot-game/bin/core/resource/sound/ISoundConfig";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ParsedInitData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedInitData";
import {ServerDataParser} from "@nolimitcity/slot-game/bin/core/server/ServerDataParser";
import {SpinController} from "@nolimitcity/slot-game/bin/core/spin/SpinController";
import {StageManager} from "@nolimitcity/slot-game/bin/core/stage/StageManager";
import {IndividualWinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/individualwin/IndividualWinPresentationController";
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {ZeroBetController} from "@nolimitcity/slot-game/bin/core/zerobet/ZeroBetController";
import {RespinZeroBetController} from "@nolimitcity/slot-game/bin/game/zerobet/RespinZeroBetController";
import {IceIceYetiBackground} from "./background/IceIceYetiBackground";
import {RandomFeatureController} from "./beforespinstoppresentation/RandomFeatureController";
import {IceIceYetiGameShaker} from "./gameshake/IceIceYetiGameShaker";
import {IceIceYetiFontConfig} from "./IceIceYetiFontConfig";
import {IceIceYetiGameAssets} from "./IceIceYetiGameAssets";
import {IceIceYetiGameConfig} from "./IceIceYetiGameConfig";
import {IceIceYetiSoundConfig} from "./IceIceYetiSoundConfig";
import {IceIceYetiIntroView} from "./intro/IceIceYetiIntroView";
import {IceIceYetiLogo} from "./logo/IceIceYetiLogo";
import {SnowStormParticles} from "./particles/SnowStormParticles";
import {IceIceYetiReels} from "./reel/reelarea/IceIceYetiReels";
import {IceIceYetiReelIceController} from "./reelice/IceIceYetiReelIceController";
import {IceIceYetiMSymbolSpinStopController} from "./reelstoppresentation/reelstop/IceIceYetiMSymbolSpinStopController";
import {SpinSoundController} from "./reelstoppresentation/spinsound/SpinSoundController";
import {IceIceYetiStickySymbolController} from "./reelstoppresentation/stickysymbol/IceIceYetiStickySymbolController";
import {IceIceYetiWildAttentionController} from "./reelstoppresentation/wildattention/IceIceYetiWildAttentionController";
import {IceIceYetiWildAttentionView} from "./reelstoppresentation/wildattention/IceIceYetiWildAttentionView";
import {IceIceYetiWildInIceReelAttentionController} from "./reelstoppresentation/wildinicereelattention/IceIceYetiWildInIceReelAttentionController";
import {IceIceYetiParsedGameData} from "./server/data/IceIceYetiParsedGameData";
import {IceIceYetiParsedInitData} from "./server/data/IceIceYetiParsedInitData";
import {IceIceYetiServerDataParser} from "./server/IceIceYetiServerDataParser";
import {IceIceYetiSpinController} from "./spin/IceIceYetiSpinController";
import {IceIceYetiReelSymbol} from "./symbol/IceIceYetiReelSymbol";
import {IceIceYetiReelSymbolStateCreator} from "./symbol/IceIceYetiReelSymbolStateCreator";
import {IceIceYetiBigWinController} from "./winpresentation/bigwin/IceIceYetiBigWinController";
import {IceIceYetiIndividualWPController} from "./winpresentation/individual/IceIceYetiIndividualWPController";
import {IceIceYetiInitialWPController} from "./winpresentation/initial/IceIceYetiInitialWPController";
import {IceIceYetiStickySymbolWPController} from "./winpresentation/stickysymbol/IceIceYetiStickySymbolWPController";
import {IceIceYetiStickySymbolWPView} from "./winpresentation/stickysymbol/IceIceYetiStickySymbolWPView";
import {IceIceYetiStickyWildWPController} from "./winpresentation/stickywild/IceIceYetiStickyWildWPController";
import {IceIceYetiWinCountUpView} from "./winpresentation/wincountup/IceIceYetiWinCountUpView";
import {IceIceYetiWinTogglePool} from "./pool/IceIceYetiWinTogglePool";

export class IceIceYetiGameModuleConfig implements IGameModuleConfig {

    public static instance:IceIceYetiGameModuleConfig = new IceIceYetiGameModuleConfig();
    public static ReelIceController:IceIceYetiReelIceController;
    private static GameShakeController:IceIceYetiGameShaker;
    public static WildAttentionView:IceIceYetiWildAttentionView;
    public static StickySymbolWPView:IceIceYetiStickySymbolWPView;
    public static WinCountUpDisplay:IceIceYetiWinCountUpView;
    public static Background:IceIceYetiBackground;
    public static SnowStormParticles:SnowStormParticles;
    public static Logo:IceIceYetiLogo;
    public static winTogglePool:IceIceYetiWinTogglePool;
    public static initialWPController:IceIceYetiInitialWPController;

    GAME_CONFIG:IGameConfig = IceIceYetiGameConfig.instance;
    SOUND_CONFIG:ISoundConfig = IceIceYetiSoundConfig.instance;
    FONTS_CONFIG:IFontsConfig = IceIceYetiFontConfig.FONTS;
    RESOURCES_CONFIG:IResourcesGroupConfig = IceIceYetiGameAssets.RESOURCES_GROUPS;

    SERVER_PARSER:() => ServerDataParser = () => new IceIceYetiServerDataParser();
    PARSED_INIT_DATA:(data:any, dataParser:ServerDataParser) => ParsedInitData =
        (data, dataParser:ServerDataParser) => new IceIceYetiParsedInitData(data, <IceIceYetiServerDataParser>dataParser);
    PARSED_GAME_DATA:(data:any, dataParser:ServerDataParser) => ParsedGameData =
        (data, dataParser:ServerDataParser) => new IceIceYetiParsedGameData(data, <IceIceYetiServerDataParser>dataParser);

    SPIN_CONTROLLER:() => SpinController = () => new IceIceYetiSpinController();

    REELS:() => Reels = () => new IceIceYetiReels();

    REEL_PART_CREATOR:() => ReelPartCreator = () => new ReelPartCreator(
        (symName:string, reelId:number, state?:ISymbolStateConfig):IceIceYetiReelSymbol => new IceIceYetiReelSymbol(symName, reelId, state)
    );

    SYMBOL_STATE_CREATOR:() => ReelSymbolStateCreator = () => new IceIceYetiReelSymbolStateCreator();

    INTRO_VIEW:(onClickCallback:() => void) => IceIceYetiIntroView =
        onClickCallback => new IceIceYetiIntroView({
            layer : IceIceYetiGameConfig.instance.LAYERS.INTRO.name,
            onButtonClickCallback : onClickCallback,
            resourceGroup : ResourcesGroupName.INTRO,
            backgroundTextures : {
                desktop : {landscape : IceIceYetiGameAssets.INTRO_BACKGROUND},
                mobile : {
                    landscape : IceIceYetiGameAssets.INTRO_BACKGROUND,
                    portrait : IceIceYetiGameAssets.INTRO_BACKGROUND
                }
            },
            mobileScale : 1.2,
            portraitScale : 1.7,
            featureIcons : {
                icons : [IntroFeatureLogo.VOLATILITY_EXTREME]
            },
        });

    ZERO_BETS:(() => ZeroBetController)[] = [
        () => new RespinZeroBetController()
    ];

    BEFORE_SPIN_STOP_PRESENTATIONS:((index:number) => BeforeSpinStopPresentationController)[] = [
        index => new RandomFeatureController(index)
    ];

    REEL_STOP_PRESENTATIONS:((index:number) => ReelStopPresentationController)[] = [
        index => new IceIceYetiMSymbolSpinStopController(index),
        index => new IceIceYetiWildAttentionController(index),
        index => new IceIceYetiStickySymbolController(index),
        index => new IceIceYetiWildInIceReelAttentionController(index),
        index => new SpinSoundController(index)
    ];

    WIN_PRESENTATIONS:((indexes:[number, number]) => WinPresentationController)[][] = [
        [indexes => new IceIceYetiStickyWildWPController(indexes)],
        [indexes => new IceIceYetiStickySymbolWPController(indexes)],
        [indexes => new IceIceYetiBigWinController(indexes)],
        [indexes => IceIceYetiGameModuleConfig.initialWPController = new IceIceYetiInitialWPController(indexes)]
    ];

    INDIVIDUAL_WIN_PRESENTATION:() => IndividualWinPresentationController = () => new IceIceYetiIndividualWPController({
        symbolTimeOffsetCalculator : (currentTotalDuration:number, reelId:number, symbolId:number):number => {
            return 0;
        }
    });

    GAME_FEATURE_CREATOR:() => void = () => {
        IceIceYetiGameModuleConfig.Background = new IceIceYetiBackground({
            layer : IceIceYetiGameConfig.instance.LAYERS.BACKGROUND.name
        });

        IceIceYetiGameModuleConfig.GameShakeController = new IceIceYetiGameShaker();
        IceIceYetiGameModuleConfig.ReelIceController = new IceIceYetiReelIceController();
        IceIceYetiGameModuleConfig.WildAttentionView = new IceIceYetiWildAttentionView(ResourcesGroupName.MAIN);
        IceIceYetiGameModuleConfig.StickySymbolWPView = new IceIceYetiStickySymbolWPView(ResourcesGroupName.MAIN);
        IceIceYetiGameModuleConfig.WinCountUpDisplay = new IceIceYetiWinCountUpView(ResourcesGroupName.MAIN);
        IceIceYetiGameModuleConfig.SnowStormParticles = new SnowStormParticles();
        IceIceYetiGameModuleConfig.Logo = new IceIceYetiLogo();
        IceIceYetiGameModuleConfig.winTogglePool = new IceIceYetiWinTogglePool();

        StageManager.legacyScaling = true;
    };

    constructor() {
        if(IceIceYetiGameModuleConfig.instance) {
            throw new Error("IceIceYetiGameModuleConfig.constructor() - Instantiation failed: Singleton.");
        }
    }
}